import { render, staticRenderFns } from "./OrganizationsPage.vue?vue&type=template&id=74874bfe&scoped=true"
import script from "./OrganizationsPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationsPage.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationsPage.vue?vue&type=style&index=0&id=74874bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74874bfe",
  null
  
)

export default component.exports